import moment from 'moment';
import { last, pipe } from 'ramda';
import { UserMessage } from 'api/conversations';
import { from, StatefulUserMessage } from './core';

const byCreatedAt = (a: UserMessage, b: UserMessage): 1 | 0 | -1 =>
  a.createdAt === b.createdAt ? 0 : a.createdAt > b.createdAt ? 1 : -1;

const asNonPrivate = (x: UserMessage) => ({
  ...x,
  private: false,
  commentMeta:
    x.commentMeta == null
      ? undefined
      : {
          ...x.commentMeta,
          repliedTo:
            x.commentMeta.repliedTo == null
              ? undefined
              : { ...x.commentMeta.repliedTo, private: false },
        },
});

export const asList = pipe(from, ({ guids, byGuid }) =>
  (guids[1] ?? [])
    .map((x) => byGuid[x])
    .filter(Boolean)
    .filter((x) => x[0] !== 'deleting')
    .map((x) => x[1])
    .map(asNonPrivate)
    .sort(byCreatedAt),
);
export const hasData = pipe(from, ({ guids }) => guids[0] === 'just');
export const isLoading = pipe(from, ({ guids }) => guids[0] === 'loading');
export const ofId = (id: number) =>
  pipe(
    from,
    ({ byId, byGuid }) => byGuid[byId[id]],
    ([s, x, y]) =>
      [
        s,
        asNonPrivate(x),
        y == null ? y : asNonPrivate(y),
      ] as StatefulUserMessage,
  );

export const hasPending = () =>
  pipe(
    asList,
    (x) => last(x),
    (x) => x != null && moment(x.createdAt).isAfter(x.lastSeenAt),
  );

export const getLastSeenAtFromComments = () =>
  pipe(
    asList,
    (x) => last(x),
    (x) => x?.lastSeenAt,
  );
